require("core-js/modules/es.array.sort.js");
module.exports = function (e) {
  var t = {};
  function n(r) {
    if (t[r]) return t[r].exports;
    var a = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }
  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      configurable: !1,
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n.w = {}, n(n.s = 27);
}([function (e, t) {
  e.exports = require("lodash");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.addDummyNode = d, t.simplify = f, t.asNonCompoundGraph = i, t.successorWeights = l, t.predecessorWeights = c, t.intersectRect = s, t.buildLayerMatrix = h, t.normalizeRanks = v, t.removeEmptyRanks = g, t.addBorderNode = p, t.maxRank = m, t.partition = E, t.time = b, t.notime = w;
  var r,
    a = n(0),
    u = (r = a) && r.__esModule ? r : {
      default: r
    },
    o = n(2);
  function d(e, t, n, r) {
    var a = void 0;
    do {
      a = u.default.uniqueId(r);
    } while (e.hasNode(a));
    return n.dummy = t, e.setNode(a, n), a;
  }
  function f(e) {
    var t = new o.Graph().setGraph(e.graph());
    return u.default.forEach(e.nodes(), function (n) {
      t.setNode(n, e.node(n));
    }), u.default.forEach(e.edges(), function (n) {
      var r = t.edge(n.v, n.w) || {
          weight: 0,
          minlen: 1
        },
        a = e.edge(n);
      t.setEdge(n.v, n.w, {
        weight: r.weight + a.weight,
        minlen: Math.max(r.minlen, a.minlen)
      });
    }), t;
  }
  function i(e) {
    var t = new o.Graph({
      multigraph: e.isMultigraph()
    }).setGraph(e.graph());
    return u.default.forEach(e.nodes(), function (n) {
      e.children(n).length || t.setNode(n, e.node(n));
    }), u.default.forEach(e.edges(), function (n) {
      t.setEdge(n, e.edge(n));
    }), t;
  }
  function l(e) {
    var t = u.default.map(e.nodes(), function (t) {
      var n = {};
      return u.default.forEach(e.outEdges(t), function (t) {
        n[t.w] = (n[t.w] || 0) + e.edge(t).weight;
      }), n;
    });
    return u.default.zipObject(e.nodes(), t);
  }
  function c(e) {
    var t = u.default.map(e.nodes(), function (t) {
      var n = {};
      return u.default.forEach(e.inEdges(t), function (t) {
        n[t.v] = (n[t.v] || 0) + e.edge(t).weight;
      }), n;
    });
    return u.default.zipObject(e.nodes(), t);
  }
  function s(e, t) {
    var n = e.x,
      r = e.y,
      a = t.x - n,
      u = t.y - r,
      o = e.width / 2,
      d = e.height / 2;
    if (!a && !u) throw new Error("Not possible to find intersection inside of the rectangle");
    var f = void 0,
      i = void 0;
    return Math.abs(u) * o > Math.abs(a) * d ? (u < 0 && (d = -d), f = d * a / u, i = d) : (a < 0 && (o = -o), f = o, i = o * u / a), {
      x: n + f,
      y: r + i
    };
  }
  function h(e) {
    var t = u.default.map(u.default.range(m(e) + 1), function () {
      return [];
    });
    return u.default.forEach(e.nodes(), function (n) {
      var r = e.node(n),
        a = r.rank;
      u.default.isUndefined(a) || (t[a][r.order] = n);
    }), t;
  }
  function v(e) {
    var t = u.default.min(u.default.map(e.nodes(), function (t) {
      return e.node(t).rank;
    }));
    u.default.forEach(e.nodes(), function (n) {
      var r = e.node(n);
      u.default.has(r, "rank") && (r.rank -= t);
    });
  }
  function g(e) {
    var t = u.default.min(u.default.map(e.nodes(), function (t) {
        return e.node(t).rank;
      })),
      n = [];
    u.default.forEach(e.nodes(), function (r) {
      var a = e.node(r).rank - t;
      n[a] || (n[a] = []), n[a].push(r);
    });
    var r = 0,
      a = e.graph().nodeRankFactor;
    u.default.forEach(n, function (t, n) {
      u.default.isUndefined(t) && n % a != 0 ? --r : r && u.default.forEach(t, function (t) {
        e.node(t).rank += r;
      });
    });
  }
  function p(e, t, n, r) {
    var a = {
      width: 0,
      height: 0
    };
    return arguments.length >= 4 && (a.rank = n, a.order = r), d(e, "border", a, t);
  }
  function m(e) {
    return u.default.max(u.default.map(e.nodes(), function (t) {
      var n = e.node(t).rank;
      if (!u.default.isUndefined(n)) return n;
    }));
  }
  function E(e, t) {
    var n = {
      lhs: [],
      rhs: []
    };
    return u.default.forEach(e, function (e) {
      t(e) ? n.lhs.push(e) : n.rhs.push(e);
    }), n;
  }
  function b(e, t) {
    var n = u.default.now();
    try {
      return t();
    } finally {
      console.log(e + " time: " + (u.default.now() - n) + "ms");
    }
  }
  function w(e, t) {
    return t();
  }
  t.default = {
    addDummyNode: d,
    simplify: f,
    asNonCompoundGraph: i,
    successorWeights: l,
    predecessorWeights: c,
    intersectRect: s,
    buildLayerMatrix: h,
    normalizeRanks: v,
    removeEmptyRanks: g,
    addBorderNode: p,
    maxRank: m,
    partition: E,
    time: b,
    notime: w
  };
}, function (e, t) {
  e.exports = require("graphlibrary");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.longestPath = o, t.slack = d;
  var r,
    a = n(0),
    u = (r = a) && r.__esModule ? r : {
      default: r
    };
  function o(e) {
    var t = {};
    u.default.forEach(e.sources(), function n(r) {
      var a = e.node(r);
      if (u.default.has(t, r)) return a.rank;
      t[r] = !0;
      var o = u.default.min(u.default.map(e.outEdges(r), function (t) {
        return n(t.w) - e.edge(t).minlen;
      })) || 0;
      return a.rank = o;
    });
  }
  function d(e, t) {
    return e.node(t.w).rank - e.node(t.v).rank - e.edge(t).minlen;
  }
  t.default = {
    longestPath: o,
    slack: d
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
    a = n(0),
    u = (r = a) && r.__esModule ? r : {
      default: r
    },
    o = n(2),
    d = n(3);
  function f(e, t) {
    return u.default.forEach(e.nodes(), function n(r) {
      u.default.forEach(t.nodeEdges(r), function (a) {
        var u = a.v,
          o = r === u ? a.w : u;
        e.hasNode(o) || (0, d.slack)(t, a) || (e.setNode(o, {}), e.setEdge(r, o, {}), n(o));
      });
    }), e.nodeCount();
  }
  function i(e, t) {
    return u.default.minBy(t.edges(), function (n) {
      if (e.hasNode(n.v) !== e.hasNode(n.w)) return (0, d.slack)(t, n);
    });
  }
  function l(e, t, n) {
    u.default.forEach(e.nodes(), function (e) {
      t.node(e).rank += n;
    });
  }
  t.default = function (e) {
    var t = new o.Graph({
        directed: !1
      }),
      n = e.nodes()[0],
      r = e.nodeCount();
    t.setNode(n, {});
    for (var a = void 0; f(t, e) < r;) a = i(t, e), l(t, e, t.hasNode(a.v) ? (0, d.slack)(e, a) : -(0, d.slack)(e, a));
    return t;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.positionX = p;
  var r = o(n(0)),
    a = n(2),
    u = o(n(1));
  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function d(e, t) {
    var n = {};
    return r.default.reduce(t, function (t, a) {
      var u = 0,
        o = 0,
        d = t.length,
        f = r.default.last(a);
      return r.default.forEach(a, function (t, l) {
        var c = function (e, t) {
            if (e.node(t).dummy) return r.default.find(e.predecessors(t), function (t) {
              return e.node(t).dummy;
            });
          }(e, t),
          s = c ? e.node(c).order : d;
        (c || t === f) && (r.default.forEach(a.slice(o, l + 1), function (t) {
          r.default.forEach(e.predecessors(t), function (r) {
            var a = e.node(r),
              o = a.order;
            !(o < u || s < o) || a.dummy && e.node(t).dummy || i(n, r, t);
          });
        }), o = l + 1, u = s);
      }), a;
    }), n;
  }
  function f(e, t) {
    var n = {};
    function a(t, a, u, o, d) {
      var f = void 0;
      r.default.forEach(r.default.range(a, u), function (a) {
        f = t[a], e.node(f).dummy && r.default.forEach(e.predecessors(f), function (t) {
          var r = e.node(t);
          r.dummy && (r.order < o || r.order > d) && i(n, t, f);
        });
      });
    }
    return r.default.reduce(t, function (t, n) {
      var u = -1,
        o = void 0,
        d = 0;
      return r.default.forEach(n, function (r, f) {
        if ("border" === e.node(r).dummy) {
          var i = e.predecessors(r);
          i.length && (o = e.node(i[0]).order, a(n, d, f, u, o), d = f, u = o);
        }
        a(n, d, n.length, o, t.length);
      }), n;
    }), n;
  }
  function i(e, t, n) {
    if (t > n) {
      var r = t;
      t = n, n = r;
    }
    var a = e[t];
    a || (e[t] = a = {}), a[n] = !0;
  }
  function l(e, t, n) {
    if (t > n) {
      var a = t;
      t = n, n = a;
    }
    return r.default.has(e[t], n);
  }
  function c(e, t, n, a) {
    var u = {},
      o = {},
      d = {};
    return r.default.forEach(t, function (e) {
      r.default.forEach(e, function (e, t) {
        u[e] = e, o[e] = e, d[e] = t;
      });
    }), r.default.forEach(t, function (e) {
      var t = -1;
      r.default.forEach(e, function (e) {
        var f = a(e);
        if (f.length) for (var i = ((f = r.default.sortBy(f, function (e) {
            return d[e];
          })).length - 1) / 2, c = Math.floor(i), s = Math.ceil(i); c <= s; ++c) {
          var h = f[c];
          o[e] === e && t < d[h] && !l(n, e, h) && (o[h] = e, o[e] = u[e] = u[h], t = d[h]);
        }
      });
    }), {
      root: u,
      align: o
    };
  }
  function s(e, t, n, u, o) {
    var d = {},
      f = function (e, t, n, u) {
        var o = new a.Graph(),
          d = e.graph(),
          f = function (e, t, n) {
            return function (a, u, o) {
              var d = a.node(u),
                f = a.node(o),
                i = 0,
                l = void 0;
              if (i += d.width / 2, r.default.has(d, "labelpos")) switch (d.labelpos.toLowerCase()) {
                case "l":
                  l = -d.width / 2;
                  break;
                case "r":
                  l = d.width / 2;
              }
              if (l && (i += n ? l : -l), l = 0, i += (d.dummy ? t : e) / 2, i += (f.dummy ? t : e) / 2, i += f.width / 2, r.default.has(f, "labelpos")) switch (f.labelpos.toLowerCase()) {
                case "l":
                  l = f.width / 2;
                  break;
                case "r":
                  l = -f.width / 2;
              }
              return l && (i += n ? l : -l), l = 0, i;
            };
          }(d.nodesep, d.edgesep, u);
        return r.default.forEach(t, function (t) {
          var a = void 0;
          r.default.forEach(t, function (t) {
            var r = n[t];
            if (o.setNode(r), a) {
              var u = n[a],
                d = o.edge(u, r);
              o.setEdge(u, r, Math.max(f(e, t, a), d || 0));
            }
            a = t;
          });
        }), o;
      }(e, t, n, o),
      i = {};
    r.default.forEach(f.nodes(), function e(t) {
      r.default.has(i, t) || (i[t] = !0, d[t] = r.default.reduce(f.inEdges(t), function (t, n) {
        return e(n.v), Math.max(t, d[n.v] + f.edge(n));
      }, 0));
    });
    var l = o ? "borderLeft" : "borderRight";
    return r.default.forEach(f.nodes(), function t(n) {
      if (2 !== i[n]) {
        i[n]++;
        var a = e.node(n),
          u = r.default.reduce(f.outEdges(n), function (e, n) {
            return t(n.w), Math.min(e, d[n.w] - f.edge(n));
          }, Number.POSITIVE_INFINITY);
        u !== Number.POSITIVE_INFINITY && a.borderType !== l && (d[n] = Math.max(d[n], u));
      }
    }), r.default.forEach(u, function (e) {
      d[e] = d[n[e]];
    }), d;
  }
  function h(e, t) {
    return r.default.minBy(r.default.values(t), function (t) {
      var n = (r.default.minBy(r.default.toPairs(t), function (t) {
        return t[1] - m(e, t[0]) / 2;
      }) || ["k", 0])[1];
      return (r.default.maxBy(r.default.toPairs(t), function (t) {
        return t[1] + m(e, t[0]) / 2;
      }) || ["k", 0])[1] - n;
    });
  }
  function v(e, t) {
    var n = r.default.values(t),
      a = r.default.min(n),
      u = r.default.max(n);
    r.default.forEach(["u", "d"], function (n) {
      r.default.forEach(["l", "r"], function (o) {
        var d = n + o,
          f = e[d];
        if (f !== t) {
          var i = r.default.values(f),
            l = "l" === o ? a - r.default.min(i) : u - r.default.max(i);
          l && (e[d] = r.default.mapValues(f, function (e) {
            return e + l;
          }));
        }
      });
    });
  }
  function g(e, t) {
    return r.default.mapValues(e.ul, function (n, a) {
      if (t) return e[t.toLowerCase()][a];
      var u = r.default.sortBy(r.default.map(e, a));
      return (u[1] + u[2]) / 2;
    });
  }
  function p(e) {
    var t = u.default.buildLayerMatrix(e),
      n = r.default.merge(d(e, t), f(e, t)),
      a = {},
      o = void 0;
    r.default.forEach(["u", "d"], function (u) {
      o = "u" === u ? t : r.default.values(t).reverse(), r.default.forEach(["l", "r"], function (t) {
        "r" === t && (o = r.default.map(o, function (e) {
          return r.default.values(e).reverse();
        }));
        var d = r.default.bind("u" === u ? e.predecessors : e.successors, e),
          f = c(0, o, n, d),
          i = s(e, o, f.root, f.align, "r" === t);
        "r" === t && (i = r.default.mapValues(i, function (e) {
          return -e;
        })), a[u + t] = i;
      });
    });
    var i = h(e, a);
    return v(a, i), g(a, e.graph().align);
  }
  function m(e, t) {
    return e.node(t).width;
  }
  t.default = {
    positionX: p,
    findType1Conflicts: d,
    findType2Conflicts: f,
    addConflict: i,
    hasConflict: l,
    verticalAlignment: c,
    horizontalCompaction: s,
    alignCoordinates: v,
    findSmallestWidthAlignment: h,
    balance: g
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(n(0)),
    a = o(n(1)),
    u = n(5);
  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    (function (e) {
      var t = a.default.buildLayerMatrix(e),
        n = e.graph().ranksep,
        u = 0;
      r.default.forEach(t, function (t) {
        var a = r.default.max(r.default.map(t, function (t) {
          return e.node(t).height;
        }));
        r.default.forEach(t, function (t) {
          e.node(t).y = u + a / 2;
        }), u += a + n;
      });
    })(e = a.default.asNonCompoundGraph(e)), r.default.forEach((0, u.positionX)(e), function (t, n) {
      e.node(n).x = t;
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
    a = n(0),
    u = (r = a) && r.__esModule ? r : {
      default: r
    };
  t.default = function (e, t, n) {
    var r = {},
      a = void 0;
    u.default.forEach(n, function (n) {
      for (var u = e.parent(n), o = void 0, d = void 0; u;) {
        if ((o = e.parent(u)) ? (d = r[o], r[o] = u) : (d = a, a = u), d && d !== u) return void t.setEdge(d, u);
        u = o;
      }
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
    a = n(0),
    u = (r = a) && r.__esModule ? r : {
      default: r
    },
    o = n(2);
  t.default = function (e, t, n) {
    var r = function (e) {
        for (var t = void 0; e.hasNode(t = u.default.uniqueId("_root")););
        return t;
      }(e),
      a = new o.Graph({
        compound: !0
      }).setGraph({
        root: r
      }).setDefaultNodeLabel(function (t) {
        return e.node(t);
      });
    return u.default.forEach(e.nodes(), function (o) {
      var d = e.node(o),
        f = e.parent(o);
      (d.rank === t || d.minRank <= t && t <= d.maxRank) && (a.setNode(o), a.setParent(o, f || r), u.default.forEach(e[n](o), function (t) {
        var n = t.v === o ? t.w : t.v,
          r = a.edge(n, o),
          d = u.default.isUndefined(r) ? 0 : r.weight;
        a.setEdge(n, o, {
          weight: e.edge(t).weight + d
        });
      }), u.default.has(d, "minRank") && a.setNode(o, {
        borderLeft: d.borderLeft[t],
        borderRight: d.borderRight[t]
      }));
    }), a;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = u(n(0)),
    a = u(n(1));
  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function o(e, t, n) {
    for (var a = void 0; t.length && (a = r.default.last(t)).i <= n;) t.pop(), e.push(a.vs), n++;
    return n;
  }
  t.default = function (e, t) {
    var n,
      u = a.default.partition(e, function (e) {
        return r.default.has(e, "barycenter");
      }),
      d = u.lhs,
      f = r.default.sortBy(u.rhs, function (e) {
        return -e.i;
      }),
      i = [],
      l = 0,
      c = 0,
      s = 0;
    d.sort((n = !!t, function (e, t) {
      return e.barycenter < t.barycenter ? -1 : e.barycenter > t.barycenter ? 1 : n ? t.i - e.i : e.i - t.i;
    })), s = o(i, f, s), r.default.forEach(d, function (e) {
      s += e.vs.length, i.push(e.vs), l += e.barycenter * e.weight, c += e.weight, s = o(i, f, s);
    });
    var h = {
      vs: r.default.flatten(i, !0)
    };
    return c && (h.barycenter = l / c, h.weight = c), h;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
    a = n(0),
    u = (r = a) && r.__esModule ? r : {
      default: r
    };
  t.default = function (e, t) {
    var n = {};
    return u.default.forEach(e, function (e, t) {
      var r = n[e.v] = {
        indegree: 0,
        in: [],
        out: [],
        vs: [e.v],
        i: t
      };
      u.default.isUndefined(e.barycenter) || (r.barycenter = e.barycenter, r.weight = e.weight);
    }), u.default.forEach(t.edges(), function (e) {
      var t = n[e.v],
        r = n[e.w];
      u.default.isUndefined(t) || u.default.isUndefined(r) || (r.indegree++, t.out.push(n[e.w]));
    }), function (e) {
      var t = [];
      function n(e) {
        return function (t) {
          var n, r, a, o;
          t.merged || (u.default.isUndefined(t.barycenter) || u.default.isUndefined(e.barycenter) || t.barycenter >= e.barycenter) && (r = t, a = 0, o = 0, (n = e).weight && (a += n.barycenter * n.weight, o += n.weight), r.weight && (a += r.barycenter * r.weight, o += r.weight), n.vs = r.vs.concat(n.vs), n.barycenter = a / o, n.weight = o, n.i = Math.min(r.i, n.i), r.merged = !0);
        };
      }
      function r(t) {
        return function (n) {
          n.in.push(t), 0 == --n.indegree && e.push(n);
        };
      }
      for (; e.length;) {
        var a = e.pop();
        t.push(a), u.default.forEach(a.in.reverse(), n(a)), u.default.forEach(a.out, r(a));
      }
      return u.default.chain(t).filter(function (e) {
        return !e.merged;
      }).map(function (e) {
        return u.default.pick(e, ["vs", "i", "barycenter", "weight"]);
      }).value();
    }(u.default.filter(n, function (e) {
      return !e.indegree;
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
    a = n(0),
    u = (r = a) && r.__esModule ? r : {
      default: r
    };
  t.default = function (e, t) {
    return u.default.map(t, function (t) {
      var n = e.inEdges(t);
      if (n.length) {
        var r = u.default.reduce(n, function (t, n) {
          var r = e.edge(n),
            a = e.node(n.v);
          return {
            sum: t.sum + r.weight * a.order,
            weight: t.weight + r.weight
          };
        }, {
          sum: 0,
          weight: 0
        });
        return {
          v: t,
          barycenter: r.sum / r.weight,
          weight: r.weight
        };
      }
      return {
        v: t
      };
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = d(n(0)),
    a = d(n(11)),
    u = d(n(10)),
    o = d(n(9));
  function d(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function e(t, n, d, f) {
    var i = t.children(n),
      l = t.node(n),
      c = l ? l.borderLeft : void 0,
      s = l ? l.borderRight : void 0,
      h = {};
    c && (i = r.default.filter(i, function (e) {
      return e !== c && e !== s;
    }));
    var v = (0, a.default)(t, i);
    r.default.forEach(v, function (n) {
      if (t.children(n.v).length) {
        var a = e(t, n.v, d, f);
        h[n.v] = a, r.default.has(a, "barycenter") && (u = n, o = a, r.default.isUndefined(u.barycenter) ? (u.barycenter = o.barycenter, u.weight = o.weight) : (u.barycenter = (u.barycenter * u.weight + o.barycenter * o.weight) / (u.weight + o.weight), u.weight += o.weight));
      }
      var u, o;
    });
    var g = (0, u.default)(v, d);
    !function (e, t) {
      r.default.forEach(e, function (e) {
        e.vs = r.default.flatten(e.vs.map(function (e) {
          return t[e] ? t[e].vs : e;
        }), !0);
      });
    }(g, h);
    var p = (0, o.default)(g, f);
    if (c && (p.vs = r.default.flatten([c, p.vs, s], !0), t.predecessors(c).length)) {
      var m = t.node(t.predecessors(c)[0]),
        E = t.node(t.predecessors(s)[0]);
      r.default.has(p, "barycenter") || (p.barycenter = 0, p.weight = 0), p.barycenter = (p.barycenter * p.weight + m.order + E.order) / (p.weight + 2), p.weight += 2;
    }
    return p;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
    a = n(0),
    u = (r = a) && r.__esModule ? r : {
      default: r
    };
  function o(e, t, n) {
    for (var r = u.default.zipObject(n, u.default.map(n, function (e, t) {
        return t;
      })), a = u.default.flatten(u.default.map(t, function (t) {
        return u.default.chain(e.outEdges(t)).map(function (t) {
          return {
            pos: r[t.w],
            weight: e.edge(t).weight
          };
        }).sortBy("pos").value();
      }), !0), o = 1; o < n.length;) o <<= 1;
    var d = 2 * o - 1;
    o -= 1;
    var f = u.default.map(new Array(d), function () {
        return 0;
      }),
      i = 0;
    return u.default.forEach(a.forEach(function (e) {
      var t = e.pos + o;
      f[t] += e.weight;
      for (var n = 0; t > 0;) t % 2 && (n += f[t + 1]), f[t = t - 1 >> 1] += e.weight;
      i += e.weight * n;
    })), i;
  }
  t.default = function (e, t) {
    for (var n = 0, r = 1; r < t.length; ++r) n += o(e, t[r - 1], t[r]);
    return n;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
    a = n(0),
    u = (r = a) && r.__esModule ? r : {
      default: r
    };
  t.default = function (e) {
    var t = {},
      n = u.default.filter(e.nodes(), function (t) {
        return !e.children(t).length;
      }),
      r = u.default.max(u.default.map(n, function (t) {
        return e.node(t).rank;
      })),
      a = u.default.map(u.default.range(r + 1), function () {
        return [];
      }),
      o = u.default.sortBy(n, function (t) {
        return e.node(t).rank;
      });
    return u.default.forEach(o, function n(r) {
      if (!u.default.has(t, r)) {
        t[r] = !0;
        var o = e.node(r);
        a[o.rank].push(r), u.default.forEach(e.successors(r), n);
      }
    }), a;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = c(n(0)),
    a = n(2),
    u = c(n(14)),
    o = c(n(13)),
    d = c(n(12)),
    f = c(n(8)),
    i = c(n(7)),
    l = c(n(1));
  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function s(e, t, n) {
    return r.default.map(t, function (t) {
      return (0, f.default)(e, t, n);
    });
  }
  function h(e, t) {
    var n = new a.Graph();
    r.default.forEach(e, function (e) {
      var a = e.graph().root,
        u = (0, d.default)(e, a, n, t);
      r.default.forEach(u.vs, function (t, n) {
        e.node(t).order = n;
      }), (0, i.default)(e, n, u.vs);
    });
  }
  function v(e, t) {
    r.default.forEach(t, function (t) {
      r.default.forEach(t, function (t, n) {
        e.node(t).order = n;
      });
    });
  }
  t.default = function (e) {
    var t = l.default.maxRank(e),
      n = s(e, r.default.range(1, t + 1), "inEdges"),
      a = s(e, r.default.range(t - 1, -1, -1), "outEdges"),
      d = (0, u.default)(e);
    v(e, d);
    for (var f = Number.POSITIVE_INFINITY, i = void 0, c = 0, g = 0; g < 4; ++c, ++g) {
      h(c % 2 ? n : a, c % 4 >= 2), d = l.default.buildLayerMatrix(e);
      var p = (0, o.default)(e, d);
      p < f && (g = 0, i = r.default.cloneDeep(d), f = p);
    }
    v(e, i);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
    a = n(0),
    u = (r = a) && r.__esModule ? r : {
      default: r
    };
  function o(e) {
    u.default.forEach(e.nodes(), function (t) {
      d(e.node(t));
    }), u.default.forEach(e.edges(), function (t) {
      d(e.edge(t));
    });
  }
  function d(e) {
    var t = e.width;
    e.width = e.height, e.height = t;
  }
  function f(e) {
    e.y = -e.y;
  }
  function i(e) {
    var t = e.x;
    e.x = e.y, e.y = t;
  }
  t.default = {
    adjust: function (e) {
      var t = e.graph().rankdir.toLowerCase();
      "lr" !== t && "rl" !== t || o(e);
    },
    undo: function (e) {
      var t = e.graph().rankdir.toLowerCase();
      "bt" !== t && "rl" !== t || function (e) {
        u.default.forEach(e.nodes(), function (t) {
          f(e.node(t));
        }), u.default.forEach(e.edges(), function (t) {
          var n = e.edge(t);
          u.default.forEach(n.points, f), u.default.has(n, "y") && f(n);
        });
      }(e), "lr" !== t && "rl" !== t || (function (e) {
        u.default.forEach(e.nodes(), function (t) {
          i(e.node(t));
        }), u.default.forEach(e.edges(), function (t) {
          var n = e.edge(t);
          u.default.forEach(n.points, i), u.default.has(n, "x") && i(n);
        });
      }(e), o(e));
    }
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = u(n(0)),
    a = u(n(1));
  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function o(e, t, n, r, u, o) {
    var d = {
        width: 0,
        height: 0,
        rank: o,
        borderType: t
      },
      f = u[t][o - 1],
      i = a.default.addDummyNode(e, "border", d, n);
    u[t][o] = i, e.setParent(i, r), f && e.setEdge(f, i, {
      weight: 1
    });
  }
  t.default = function (e) {
    r.default.forEach(e.children(), function t(n) {
      var a = e.children(n),
        u = e.node(n);
      if (a.length && r.default.forEach(a, t), r.default.has(u, "minRank")) {
        u.borderLeft = [], u.borderRight = [];
        for (var d = u.minRank, f = u.maxRank + 1; d < f; ++d) o(e, "borderLeft", "_bl", n, u, d), o(e, "borderRight", "_br", n, u, d);
      }
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = u(n(0)),
    a = u(n(1));
  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = {
    run: function (e) {
      var t = a.default.addDummyNode(e, "root", {}, "_root"),
        n = function (e) {
          var t = {};
          return r.default.forEach(e.children(), function (n) {
            !function n(a, u) {
              var o = e.children(a);
              o && o.length && r.default.forEach(o, function (e) {
                n(e, u + 1);
              }), t[a] = u;
            }(n, 1);
          }), t;
        }(e),
        u = r.default.max(r.default.values(n)) - 1,
        o = 2 * u + 1;
      e.graph().nestingRoot = t, r.default.forEach(e.edges(), function (t) {
        e.edge(t).minlen *= o;
      });
      var d = function (e) {
        return r.default.reduce(e.edges(), function (t, n) {
          return t + e.edge(n).weight;
        }, 0);
      }(e) + 1;
      r.default.forEach(e.children(), function (f) {
        !function e(t, n, u, o, d, f, i) {
          var l = t.children(i);
          if (l.length) {
            var c = a.default.addBorderNode(t, "_bt"),
              s = a.default.addBorderNode(t, "_bb"),
              h = t.node(i);
            t.setParent(c, i), h.borderTop = c, t.setParent(s, i), h.borderBottom = s, r.default.forEach(l, function (r) {
              e(t, n, u, o, d, f, r);
              var a = t.node(r),
                l = a.borderTop ? a.borderTop : r,
                h = a.borderBottom ? a.borderBottom : r,
                v = a.borderTop ? o : 2 * o,
                g = l !== h ? 1 : d - f[i] + 1;
              t.setEdge(c, l, {
                weight: v,
                minlen: g,
                nestingEdge: !0
              }), t.setEdge(h, s, {
                weight: v,
                minlen: g,
                nestingEdge: !0
              });
            }), t.parent(i) || t.setEdge(n, c, {
              weight: 0,
              minlen: d + f[i]
            });
          } else i !== n && t.setEdge(n, i, {
            weight: 0,
            minlen: u
          });
        }(e, t, o, d, u, n, f);
      }), e.graph().nodeRankFactor = o;
    },
    cleanup: function (e) {
      var t = e.graph();
      e.removeNode(t.nestingRoot), delete t.nestingRoot, r.default.forEach(e.edges(), function (t) {
        e.edge(t).nestingEdge && e.removeEdge(t);
      });
    }
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
    a = n(0),
    u = (r = a) && r.__esModule ? r : {
      default: r
    };
  t.default = function (e) {
    var t = function (e) {
      var t = {},
        n = 0;
      return u.default.forEach(e.children(), function r(a) {
        var o = n;
        u.default.forEach(e.children(a), r), t[a] = {
          low: o,
          lim: n++
        };
      }), t;
    }(e);
    u.default.forEach(e.graph().dummyChains, function (n) {
      for (var r = e.node(n), a = r.edgeObj, u = function (e, t, n, r) {
          var a = [],
            u = [],
            o = Math.min(t[n].low, t[r].low),
            d = Math.max(t[n].lim, t[r].lim),
            f = void 0,
            i = void 0;
          f = n;
          do {
            f = e.parent(f), a.push(f);
          } while (f && (t[f].low > o || d > t[f].lim));
          for (i = f, f = r; (f = e.parent(f)) !== i;) u.push(f);
          return {
            path: a.concat(u.reverse()),
            lca: i
          };
        }(e, t, a.v, a.w), o = u.path, d = u.lca, f = 0, i = o[f], l = !0; n !== a.w;) {
        if (r = e.node(n), l) {
          for (; (i = o[f]) !== d && e.node(i).maxRank < r.rank;) f++;
          i === d && (l = !1);
        }
        if (!l) {
          for (; f < o.length - 1 && e.node(i = o[f + 1]).minRank <= r.rank;) f++;
          i = o[f];
        }
        e.setParent(n, i), n = e.successors(n)[0];
      }
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = f(n(0)),
    a = n(2),
    u = f(n(4)),
    o = n(3),
    d = n(1);
  function f(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var i = a.alg.preorder,
    l = a.alg.postorder;
  function c(e) {
    e = (0, d.simplify)(e), (0, o.longestPath)(e);
    var t = (0, u.default)(e);
    v(t), s(t, e);
    for (var n = void 0; n = g(t);) m(t, e, n, p(t, e, n));
  }
  function s(e, t) {
    var n = l(e, e.nodes());
    n = n.slice(0, n.length - 1), r.default.forEach(n, function (n) {
      !function (e, t, n) {
        var r = e.node(n).parent;
        e.edge(n, r).cutvalue = h(e, t, n);
      }(e, t, n);
    });
  }
  function h(e, t, n) {
    var a = e.node(n).parent,
      u = !0,
      o = t.edge(n, a),
      d = 0;
    return o || (u = !1, o = t.edge(a, n)), d = o.weight, r.default.forEach(t.nodeEdges(n), function (r) {
      var o,
        f,
        i = r.v === n,
        l = i ? r.w : r.v;
      if (l !== a) {
        var c = i === u,
          s = t.edge(r).weight;
        if (d += c ? s : -s, o = n, f = l, e.hasEdge(o, f)) {
          var h = e.edge(n, l).cutvalue;
          d += c ? -h : h;
        }
      }
    }), d;
  }
  function v(e, t) {
    arguments.length < 2 && (t = e.nodes()[0]), function e(t, n, a, u, o) {
      var d = a;
      var f = t.node(u);
      n[u] = !0;
      r.default.forEach(t.neighbors(u), function (o) {
        r.default.has(n, o) || (a = e(t, n, a, o, u));
      });
      f.low = d;
      f.lim = a++;
      o ? f.parent = o : delete f.parent;
      return a;
    }(e, {}, 1, t);
  }
  function g(e) {
    return r.default.find(e.edges(), function (t) {
      return e.edge(t).cutvalue < 0;
    });
  }
  function p(e, t, n) {
    var a = n.v,
      u = n.w;
    t.hasEdge(a, u) || (a = n.w, u = n.v);
    var d = e.node(a),
      f = e.node(u),
      i = d,
      l = !1;
    d.lim > f.lim && (i = f, l = !0);
    var c = r.default.filter(t.edges(), function (t) {
      return l === E(e, e.node(t.v), i) && l !== E(e, e.node(t.w), i);
    });
    return r.default.minBy(c, function (e) {
      return (0, o.slack)(t, e);
    });
  }
  function m(e, t, n, a) {
    var u = n.v,
      o = n.w;
    e.removeEdge(u, o), e.setEdge(a.v, a.w, {}), v(e), s(e, t), function (e, t) {
      var n = r.default.find(e.nodes(), function (e) {
          return !t.node(e).parent;
        }),
        a = i(e, n);
      a = a.slice(1), r.default.forEach(a, function (n) {
        var r = e.node(n).parent,
          a = t.edge(n, r),
          u = !1;
        a || (a = t.edge(r, n), u = !0), t.node(n).rank = t.node(r).rank + (u ? a.minlen : -a.minlen);
      });
    }(e, t);
  }
  function E(e, t, n) {
    return n.low <= t.lim && t.lim <= n.lim;
  }
  c.initLowLimValues = v, c.initCutValues = s, c.calcCutValue = h, c.leaveEdge = g, c.enterEdge = p, c.exchangeEdges = m, t.default = c;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(3),
    a = o(n(4)),
    u = o(n(20));
  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var d = r.longestPath;
  function f(e) {
    (0, u.default)(e);
  }
  t.default = function (e) {
    switch (e.graph().ranker) {
      case "network-simplex":
        f(e);
        break;
      case "tight-tree":
        !function (e) {
          (0, r.longestPath)(e), (0, a.default)(e);
        }(e);
        break;
      case "longest-path":
        d(e);
        break;
      default:
        f(e);
    }
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = u(n(0)),
    a = u(n(1));
  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = {
    run: function (e) {
      e.graph().dummyChains = [], r.default.forEach(e.edges(), function (t) {
        !function (e, t) {
          var n = t.v,
            r = e.node(n).rank,
            u = t.w,
            o = e.node(u).rank,
            d = t.name,
            f = e.edge(t),
            i = f.labelRank;
          if (o !== r + 1) {
            e.removeEdge(t);
            var l = void 0,
              c = void 0,
              s = void 0;
            for (s = 0, ++r; r < o; ++s, ++r) f.points = [], c = {
              width: 0,
              height: 0,
              edgeLabel: f,
              edgeObj: t,
              rank: r
            }, l = a.default.addDummyNode(e, "edge", c, "_d"), r === i && (c.width = f.width, c.height = f.height, c.dummy = "edge-label", c.labelpos = f.labelpos), e.setEdge(n, l, {
              weight: f.weight
            }, d), 0 === s && e.graph().dummyChains.push(l), n = l;
            e.setEdge(n, u, {
              weight: f.weight
            }, d);
          }
        }(e, t);
      });
    },
    undo: function (e) {
      r.default.forEach(e.graph().dummyChains, function (t) {
        var n = e.node(t),
          r = n.edgeLabel,
          a = null;
        for (e.setEdge(n.edgeObj, r); n.dummy;) a = e.successors(t)[0], e.removeNode(t), r.points.push({
          x: n.x,
          y: n.y
        }), "edge-label" === n.dummy && (r.x = n.x, r.y = n.y, r.width = n.width, r.height = n.height), t = a, n = e.node(t);
      });
    }
  };
}, function (e, t, n) {
  "use strict";

  function r() {
    var e = {};
    e._next = e._prev = e, this._sentinel = e;
  }
  function a(e) {
    e._prev._next = e._next, e._next._prev = e._prev, delete e._next, delete e._prev;
  }
  function u(e, t) {
    if ("_next" !== e && "_prev" !== e) return t;
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), r.prototype.dequeue = function () {
    var e = this._sentinel,
      t = e._prev;
    if (t !== e) return a(t), t;
  }, r.prototype.enqueue = function (e) {
    var t = this._sentinel;
    e._prev && e._next && a(e), e._next = t._next, t._next._prev = e, t._next = e, e._prev = t;
  }, r.prototype.toString = function () {
    for (var e = [], t = this._sentinel, n = t._prev; n !== t;) e.push(JSON.stringify(n, u)), n = n._prev;
    return "[" + e.join(", ") + "]";
  }, t.default = r;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = o(n(0)),
    a = n(2),
    u = o(n(23));
  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var d = r.default.constant(1);
  function f(e, t, n, a, u) {
    var o = u ? [] : void 0;
    return r.default.forEach(e.inEdges(a.v), function (r) {
      var a = e.edge(r),
        d = e.node(r.v);
      u && o.push({
        v: r.v,
        w: r.w
      }), d.out -= a, i(t, n, d);
    }), r.default.forEach(e.outEdges(a.v), function (r) {
      var a = e.edge(r),
        u = r.w,
        o = e.node(u);
      o.in -= a, i(t, n, o);
    }), e.removeNode(a.v), o;
  }
  function i(e, t, n) {
    n.out ? n.in ? e[n.out - n.in + t].enqueue(n) : e[e.length - 1].enqueue(n) : e[0].enqueue(n);
  }
  t.default = function (e, t) {
    if (e.nodeCount() <= 1) return [];
    var n = function (e, t) {
        var n = new a.Graph(),
          o = 0,
          d = 0;
        r.default.forEach(e.nodes(), function (e) {
          n.setNode(e, {
            v: e,
            in: 0,
            out: 0
          });
        }), r.default.forEach(e.edges(), function (e) {
          var r = n.edge(e.v, e.w) || 0,
            a = t(e),
            u = r + a;
          n.setEdge(e.v, e.w, u), d = Math.max(d, n.node(e.v).out += a), o = Math.max(o, n.node(e.w).in += a);
        });
        var f = r.default.range(d + o + 3).map(function () {
            return new u.default();
          }),
          l = o + 1;
        return r.default.forEach(n.nodes(), function (e) {
          i(f, l, n.node(e));
        }), {
          graph: n,
          buckets: f,
          zeroIdx: l
        };
      }(e, t || d),
      o = function (e, t, n) {
        for (var r = [], a = t[t.length - 1], u = t[0], o = void 0; e.nodeCount();) {
          for (; o = u.dequeue();) f(e, t, n, o);
          for (; o = a.dequeue();) f(e, t, n, o);
          if (e.nodeCount()) for (var d = t.length - 2; d > 0; --d) if (o = t[d].dequeue()) {
            r = r.concat(f(e, t, n, o, !0));
            break;
          }
        }
        return r;
      }(n.graph, n.buckets, n.zeroIdx);
    return r.default.flatten(r.default.map(o, function (t) {
      return e.outEdges(t.v, t.w);
    }), !0);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = u(n(0)),
    a = u(n(24));
  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = {
    run: function (e) {
      var t = "greedy" === e.graph().acyclicer ? (0, a.default)(e, function (e) {
        return function (t) {
          return e.edge(t).weight;
        };
      }(e)) : function (e) {
        var t = [],
          n = {},
          a = {};
        return r.default.forEach(e.nodes(), function u(o) {
          r.default.has(a, o) || (a[o] = !0, n[o] = !0, r.default.forEach(e.outEdges(o), function (e) {
            r.default.has(n, e.w) ? t.push(e) : u(e.w);
          }), delete n[o]);
        }), t;
      }(e);
      r.default.forEach(t, function (t) {
        var n = e.edge(t);
        e.removeEdge(t), n.forwardName = t.name, n.reversed = !0, e.setEdge(t.w, t.v, n, r.default.uniqueId("rev"));
      });
    },
    undo: function (e) {
      r.default.forEach(e.edges(), function (t) {
        var n = e.edge(t);
        if (n.reversed) {
          e.removeEdge(t);
          var r = n.forwardName;
          delete n.reversed, delete n.forwardName, e.setEdge(t.w, t.v, n, r);
        }
      });
    }
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = p(n(0)),
    a = n(2),
    u = p(n(25)),
    o = p(n(22)),
    d = p(n(21)),
    f = n(1),
    i = p(f),
    l = p(n(19)),
    c = p(n(18)),
    s = p(n(17)),
    h = p(n(16)),
    v = p(n(15)),
    g = p(n(6));
  function p(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var m = ["nodesep", "edgesep", "ranksep", "marginx", "marginy"],
    E = {
      ranksep: 50,
      edgesep: 20,
      nodesep: 50,
      rankdir: "tb"
    },
    b = ["acyclicer", "ranker", "rankdir", "align"],
    w = ["width", "height"],
    y = {
      width: 0,
      height: 0
    },
    _ = ["minlen", "weight", "width", "height", "labeloffset"],
    x = {
      minlen: 1,
      weight: 1,
      width: 0,
      height: 0,
      labeloffset: 10,
      labelpos: "r"
    },
    k = ["labelpos"];
  function M(e, t) {
    return r.default.mapValues(r.default.pick(e, t), Number);
  }
  function N(e) {
    var t = {};
    return r.default.forEach(e, function (e, n) {
      t[n.toLowerCase()] = e;
    }), t;
  }
  t.default = function (e, t) {
    var n = t && t.debugTiming ? i.default.time : i.default.notime;
    n("layout", function () {
      var t = n("  buildLayoutGraph", function () {
        return function (e) {
          var t = new a.Graph({
              multigraph: !0,
              compound: !0
            }),
            n = N(e.graph());
          return t.setGraph(r.default.merge({}, E, M(n, m), r.default.pick(n, b))), r.default.forEach(e.nodes(), function (n) {
            var a = N(e.node(n));
            t.setNode(n, r.default.defaults(M(a, w), y)), t.setParent(n, e.parent(n));
          }), r.default.forEach(e.edges(), function (n) {
            var a = N(e.edge(n));
            t.setEdge(n, r.default.merge({}, x, M(a, _), r.default.pick(a, k)));
          }), t;
        }(e);
      });
      n("  runLayout", function () {
        !function (e, t) {
          t("    makeSpaceForEdgeLabels", function () {
            !function (e) {
              var t = e.graph();
              t.ranksep /= 2, r.default.forEach(e.edges(), function (n) {
                var r = e.edge(n);
                r.minlen *= 2, "c" !== r.labelpos.toLowerCase() && ("TB" === t.rankdir || "BT" === t.rankdir ? r.width += r.labeloffset : r.height += r.labeloffset);
              });
            }(e);
          }), t("    removeSelfEdges", function () {
            !function (e) {
              r.default.forEach(e.edges(), function (t) {
                if (t.v === t.w) {
                  var n = e.node(t.v);
                  n.selfEdges || (n.selfEdges = []), n.selfEdges.push({
                    e: t,
                    label: e.edge(t)
                  }), e.removeEdge(t);
                }
              });
            }(e);
          }), t("    acyclic", function () {
            u.default.run(e);
          }), t("    nestingGraph.run", function () {
            c.default.run(e);
          }), t("    rank", function () {
            (0, d.default)(i.default.asNonCompoundGraph(e));
          }), t("    injectEdgeLabelProxies", function () {
            !function (e) {
              r.default.forEach(e.edges(), function (t) {
                var n = e.edge(t);
                if (n.width && n.height) {
                  var r = e.node(t.v),
                    a = e.node(t.w),
                    u = {
                      rank: (a.rank - r.rank) / 2 + r.rank,
                      e: t
                    };
                  i.default.addDummyNode(e, "edge-proxy", u, "_ep");
                }
              });
            }(e);
          }), t("    removeEmptyRanks", function () {
            (0, f.removeEmptyRanks)(e);
          }), t("    nestingGraph.cleanup", function () {
            c.default.cleanup(e);
          }), t("    normalizeRanks", function () {
            (0, f.normalizeRanks)(e);
          }), t("    assignRankMinMax", function () {
            !function (e) {
              var t = 0;
              r.default.forEach(e.nodes(), function (n) {
                var r = e.node(n);
                r.borderTop && (r.minRank = e.node(r.borderTop).rank, r.maxRank = e.node(r.borderBottom).rank, t = Math.max(t, r.maxRank));
              }), e.graph().maxRank = t;
            }(e);
          }), t("    removeEdgeLabelProxies", function () {
            !function (e) {
              r.default.forEach(e.nodes(), function (t) {
                var n = e.node(t);
                "edge-proxy" === n.dummy && (e.edge(n.e).labelRank = n.rank, e.removeNode(t));
              });
            }(e);
          }), t("    normalize.run", function () {
            o.default.run(e);
          }), t("    parentDummyChains", function () {
            (0, l.default)(e);
          }), t("    addBorderSegments", function () {
            (0, s.default)(e);
          }), t("    order", function () {
            (0, v.default)(e);
          }), t("    insertSelfEdges", function () {
            !function (e) {
              var t = i.default.buildLayerMatrix(e);
              r.default.forEach(t, function (t) {
                var n = 0;
                r.default.forEach(t, function (t, a) {
                  var u = e.node(t);
                  u.order = a + n, r.default.forEach(u.selfEdges, function (t) {
                    i.default.addDummyNode(e, "selfedge", {
                      width: t.label.width,
                      height: t.label.height,
                      rank: u.rank,
                      order: a + ++n,
                      e: t.e,
                      label: t.label
                    }, "_se");
                  }), delete u.selfEdges;
                });
              });
            }(e);
          }), t("    adjustCoordinateSystem", function () {
            h.default.adjust(e);
          }), t("    position", function () {
            (0, g.default)(e);
          }), t("    positionSelfEdges", function () {
            !function (e) {
              r.default.forEach(e.nodes(), function (t) {
                var n = e.node(t);
                if ("selfedge" === n.dummy) {
                  var r = e.node(n.e.v),
                    a = r.x + r.width / 2,
                    u = r.y,
                    o = n.x - a,
                    d = r.height / 2;
                  e.setEdge(n.e, n.label), e.removeNode(t), n.label.points = [{
                    x: a + 2 * o / 3,
                    y: u - d
                  }, {
                    x: a + 5 * o / 6,
                    y: u - d
                  }, {
                    x: a + o,
                    y: u
                  }, {
                    x: a + 5 * o / 6,
                    y: u + d
                  }, {
                    x: a + 2 * o / 3,
                    y: u + d
                  }], n.label.x = n.x, n.label.y = n.y;
                }
              });
            }(e);
          }), t("    removeBorderNodes", function () {
            !function (e) {
              r.default.forEach(e.nodes(), function (t) {
                if (e.children(t).length) {
                  var n = e.node(t),
                    a = e.node(n.borderTop),
                    u = e.node(n.borderBottom),
                    o = e.node(r.default.last(n.borderLeft)),
                    d = e.node(r.default.last(n.borderRight));
                  n.width = Math.abs(d.x - o.x), n.height = Math.abs(u.y - a.y), n.x = o.x + n.width / 2, n.y = a.y + n.height / 2;
                }
              }), r.default.forEach(e.nodes(), function (t) {
                "border" === e.node(t).dummy && e.removeNode(t);
              });
            }(e);
          }), t("    normalize.undo", function () {
            o.default.undo(e);
          }), t("    fixupEdgeLabelCoords", function () {
            !function (e) {
              r.default.forEach(e.edges(), function (t) {
                var n = e.edge(t);
                if (r.default.has(n, "x")) switch ("l" !== n.labelpos && "r" !== n.labelpos || (n.width -= n.labeloffset), n.labelpos) {
                  case "l":
                    n.x -= n.width / 2 + n.labeloffset;
                    break;
                  case "r":
                    n.x += n.width / 2 + n.labeloffset;
                }
              });
            }(e);
          }), t("    undoCoordinateSystem", function () {
            h.default.undo(e);
          }), t("    translateGraph", function () {
            !function (e) {
              var t = Number.POSITIVE_INFINITY,
                n = 0,
                a = Number.POSITIVE_INFINITY,
                u = 0,
                o = e.graph(),
                d = o.marginx || 0,
                f = o.marginy || 0;
              function i(e) {
                var r = e.x,
                  o = e.y,
                  d = e.width,
                  f = e.height;
                t = Math.min(t, r - d / 2), n = Math.max(n, r + d / 2), a = Math.min(a, o - f / 2), u = Math.max(u, o + f / 2);
              }
              r.default.forEach(e.nodes(), function (t) {
                i(e.node(t));
              }), r.default.forEach(e.edges(), function (t) {
                var n = e.edge(t);
                r.default.has(n, "x") && i(n);
              }), t -= d, a -= f, r.default.forEach(e.nodes(), function (n) {
                var r = e.node(n);
                r.x -= t, r.y -= a;
              }), r.default.forEach(e.edges(), function (n) {
                var u = e.edge(n);
                r.default.forEach(u.points, function (e) {
                  e.x -= t, e.y -= a;
                }), r.default.has(u, "x") && (u.x -= t), r.default.has(u, "y") && (u.y -= a);
              }), o.width = n - t + d, o.height = u - a + f;
            }(e);
          }), t("    assignNodeIntersects", function () {
            !function (e) {
              r.default.forEach(e.edges(), function (t) {
                var n = e.edge(t),
                  r = e.node(t.v),
                  a = e.node(t.w),
                  u = null,
                  o = null;
                n.points ? (u = n.points[0], o = n.points[n.points.length - 1]) : (n.points = [], u = a, o = r), n.points.unshift(i.default.intersectRect(r, u)), n.points.push(i.default.intersectRect(a, o));
              });
            }(e);
          }), t("    reversePoints", function () {
            !function (e) {
              r.default.forEach(e.edges(), function (t) {
                var n = e.edge(t);
                n.reversed && n.points.reverse();
              });
            }(e);
          }), t("    acyclic.undo", function () {
            u.default.undo(e);
          });
        }(t, n);
      }), n("  updateInputGraph", function () {
        !function (e, t) {
          r.default.forEach(e.nodes(), function (n) {
            var r = e.node(n),
              a = t.node(n);
            r && (r.x = a.x, r.y = a.y, t.children(n).length && (r.width = a.width, r.height = a.height));
          }), r.default.forEach(e.edges(), function (n) {
            var a = e.edge(n),
              u = t.edge(n);
            a.points = u.points, r.default.has(u, "x") && (a.x = u.x, a.y = u.y);
          }), e.graph().width = t.graph().width, e.graph().height = t.graph().height;
        }(e, t);
      });
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
    a = n(26),
    u = (r = a) && r.__esModule ? r : {
      default: r
    };
  t.default = {
    layout: u.default
  };
}]);